import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const FileIcon = ({
  color = 'foraBlue',
  width = 30,
  marginLeft,
  marginRight,
  containerSize,
  title = 'Fora',
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0164 8.54547L19.1818 8.7109V25.5909H2.81816V2.4091H12.88L13.0454 2.57454V6.50001C13.0454 7.62968 13.9612 8.54547 15.0909 8.54547H19.0164ZM0.772705 2.00001C0.772705 1.09627 1.50533 0.363647 2.40907 0.363647H13.0494C13.4834 0.363647 13.8997 0.53605 14.2065 0.842927L20.748 7.38437C21.0548 7.69124 21.2272 8.10746 21.2272 8.54145V26C21.2272 26.9038 20.4946 27.6364 19.5909 27.6364H2.40907C1.50533 27.6364 0.772705 26.9038 0.772705 26V2.00001ZM6.22712 14C5.77525 14 5.40894 14.3663 5.40894 14.8182C5.40894 15.2701 5.77525 15.6364 6.22712 15.6364H15.7726C16.2244 15.6364 16.5908 15.2701 16.5908 14.8182C16.5908 14.3663 16.2244 14 15.7726 14H6.22712ZM5.40894 19.5909C5.40894 19.1391 5.77525 18.7727 6.22712 18.7727H15.7726C16.2244 18.7727 16.5908 19.1391 16.5908 19.5909C16.5908 20.0428 16.2244 20.4091 15.7726 20.4091H6.22712C5.77525 20.4091 5.40894 20.0428 5.40894 19.5909Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
